import * as PIXI from "pixi.js";
import { FontManager } from "../../manager/FontManager";
/*
 * AbstractViewProperties.ts
 */
export class AbstractViewProperties {
    constructor(position) {
        this.position = position ?? new PIXI.Point();
        this.scale = new PIXI.Point(1, 1);
        this.rotation = 0;
        this.hitArea = null;
        this.trackingId = null;
        this.visible = null;
        this.forceResponsive = false;
        this.name = "";
        this.accessibleOptions = null;
    }
    getFont(mapping) {
        return FontManager.getInstance().getMapping(mapping);
    }
    hitAreaEquals(other) {
        if (!this.hitArea) {
            return this.hitArea === other;
        }
        else if (this.hitArea instanceof PIXI.Circle) {
            return (other instanceof PIXI.Circle &&
                this.hitArea.x === other.x &&
                this.hitArea.y === other.y &&
                this.hitArea.radius === other.radius);
        }
        else if (this.hitArea instanceof PIXI.Rectangle) {
            return (other instanceof PIXI.Rectangle &&
                this.hitArea.x === other.x &&
                this.hitArea.y === other.y &&
                this.hitArea.width === other.width &&
                this.hitArea.height === other.height);
        }
        else if (this.hitArea instanceof PIXI.Ellipse) {
            return (other instanceof PIXI.Ellipse &&
                this.hitArea.x === other.x &&
                this.hitArea.y === other.y &&
                this.hitArea.width === other.width &&
                this.hitArea.height === other.height);
        }
        else if (this.hitArea instanceof PIXI.RoundedRectangle) {
            return (other instanceof PIXI.RoundedRectangle &&
                this.hitArea.x === other.x &&
                this.hitArea.y === other.y &&
                this.hitArea.width === other.width &&
                this.hitArea.height === other.height &&
                this.hitArea.radius === other.radius);
        }
    }
    equals(other) {
        return (!this.forceResponsive &&
            (this.position
                ? this.position.equals(other.position)
                : this.position === other.position) &&
            (this.scale
                ? this.scale.equals(other.scale)
                : this.scale === other.scale) &&
            this.rotation === other.rotation &&
            this.hitAreaEquals(other.hitArea) &&
            (this.filterProperties
                ? this.filterProperties.every((value, index) => other.filterProperties[index].equals(value))
                : this.filterProperties === other.filterProperties) &&
            this.trackingId === other.trackingId &&
            this.visible === other.visible);
    }
}
//# sourceMappingURL=AbstractViewProperties.js.map